import product from "./list_en";
import product_edit from "./edit_en";
import product_category from "./category_list_en";
import product_brand from "./brand_list_en";
import product_attr from "./attr_list_en";
/**
 * 简写说明
 * fl: form label
 * fp: form placeholder
 * tl: table label
 * tr: table row
 * dt: dialog title
 * dl: dialog label
 * dp: dialog placeholder
 * db: dialog button
 * em: error message
 * sm: success message
 */
const productModel = {
    product,
    product_edit,
    product_category,
    product_brand,
    product_attr
};

export default productModel;
